export interface PreciousMetal {
  id: string;
  name_fr: string;
  name_en: string;
  category: 'gold_coin' | 'gold_bar' | 'silver' | 'platinum' | 'palladium' | 'other';
  emoji: string;
  popular?: boolean;
}

export const PRECIOUS_METALS: PreciousMetal[] = [
  // Gold coins - Most popular
  {
    id: 'napoleon_iii_tete_lauree',
    name_fr: '20 francs Napoléon III (Tête laurée)',
    name_en: '20 Francs Napoleon III (Laureate Head)',
    category: 'gold_coin',
    emoji: '🪙',
    popular: true,
  },
  {
    id: 'napoleon_iii_tete_nue',
    name_fr: '20 francs Napoléon III (Tête nue)',
    name_en: '20 Francs Napoleon III (Bare Head)',
    category: 'gold_coin',
    emoji: '🪙',
    popular: true,
  },
  {
    id: 'coq_20f',
    name_fr: '20 francs Coq (Liberté, égalité, fraternité)',
    name_en: '20 Francs Rooster (Liberty, Equality, Fraternity)',
    category: 'gold_coin',
    emoji: '🪙',
    popular: true,
  },
  {
    id: 'louis_or',
    name_fr: "Louis d'Or",
    name_en: "Louis d'Or",
    category: 'gold_coin',
    emoji: '🪙',
    popular: true,
  },
  {
    id: 'krugerrand',
    name_fr: 'Krugerrand',
    name_en: 'Krugerrand',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'american_eagle_gold',
    name_fr: 'American Eagle Or',
    name_en: 'American Gold Eagle',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'maple_leaf_gold',
    name_fr: 'Maple Leaf Or',
    name_en: 'Gold Maple Leaf',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'britannia_gold',
    name_fr: 'Britannia Or',
    name_en: 'Gold Britannia',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'philharmonique_gold',
    name_fr: 'Philharmonique de Vienne Or',
    name_en: 'Vienna Philharmonic Gold',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'panda_gold',
    name_fr: 'Panda Chinois Or',
    name_en: 'Chinese Gold Panda',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'souverain_or',
    name_fr: 'Souverain Or',
    name_en: 'Gold Sovereign',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: '50_pesos_gold',
    name_fr: '50 Pesos Or Mexicain',
    name_en: '50 Mexican Gold Pesos',
    category: 'gold_coin',
    emoji: '🪙',
  },
  {
    id: 'buffalo_gold',
    name_fr: 'American Buffalo Or',
    name_en: 'American Gold Buffalo',
    category: 'gold_coin',
    emoji: '🪙',
  },

  // Gold bars & ingots
  {
    id: 'gold_1g',
    name_fr: '1g Or',
    name_en: '1g Gold',
    category: 'gold_bar',
    emoji: '🟨',
    popular: true,
  },
  { id: 'gold_5g', name_fr: '5g Or', name_en: '5g Gold', category: 'gold_bar', emoji: '🟨' },
  {
    id: 'gold_10g',
    name_fr: 'Lingotin 10g Or',
    name_en: '10g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
    popular: true,
  },
  {
    id: 'gold_20g',
    name_fr: 'Lingotin 20g Or',
    name_en: '20g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_50g',
    name_fr: 'Lingotin 50g Or',
    name_en: '50g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_100g',
    name_fr: 'Lingot 100g Or',
    name_en: '100g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_250g',
    name_fr: 'Lingot 250g Or',
    name_en: '250g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_500g',
    name_fr: 'Lingot 500g Or',
    name_en: '500g Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_1kg',
    name_fr: 'Lingot 1 kg Or',
    name_en: '1kg Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
  },
  {
    id: 'gold_1oz',
    name_fr: 'Lingotin 1 Once Or',
    name_en: '1 Oz Gold Bar',
    category: 'gold_bar',
    emoji: '🟨',
    popular: true,
  },

  // Silver
  {
    id: 'silver_1g',
    name_fr: '1g Argent',
    name_en: '1g Silver',
    category: 'silver',
    emoji: '🥈',
    popular: true,
  },
  {
    id: 'silver_10g',
    name_fr: '10g Argent',
    name_en: '10g Silver',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'silver_100g',
    name_fr: '100g Argent',
    name_en: '100g Silver',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'silver_1kg',
    name_fr: '1 kg Argent',
    name_en: '1kg Silver',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'silver_1oz',
    name_fr: '1 Once Argent',
    name_en: '1 Oz Silver',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'american_eagle_silver',
    name_fr: 'American Eagle Argent',
    name_en: 'American Silver Eagle',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'maple_leaf_silver',
    name_fr: 'Maple Leaf Argent',
    name_en: 'Silver Maple Leaf',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'britannia_silver',
    name_fr: 'Britannia Argent',
    name_en: 'Silver Britannia',
    category: 'silver',
    emoji: '🥈',
  },
  {
    id: 'philharmonique_silver',
    name_fr: 'Philharmonique de Vienne Argent',
    name_en: 'Vienna Philharmonic Silver',
    category: 'silver',
    emoji: '🥈',
  },

  // Platinum
  {
    id: 'platinum_1oz',
    name_fr: '1 Once Platine',
    name_en: '1 Oz Platinum',
    category: 'platinum',
    emoji: '⚪',
  },
  {
    id: 'platinum_10g',
    name_fr: '10g Platine',
    name_en: '10g Platinum',
    category: 'platinum',
    emoji: '⚪',
  },
  {
    id: 'platinum_100g',
    name_fr: '100g Platine',
    name_en: '100g Platinum',
    category: 'platinum',
    emoji: '⚪',
  },
  {
    id: 'maple_leaf_platinum',
    name_fr: 'Maple Leaf Platine',
    name_en: 'Platinum Maple Leaf',
    category: 'platinum',
    emoji: '⚪',
  },
  {
    id: 'american_eagle_platinum',
    name_fr: 'American Eagle Platine',
    name_en: 'American Platinum Eagle',
    category: 'platinum',
    emoji: '⚪',
  },

  // Palladium
  {
    id: 'palladium_1oz',
    name_fr: '1 Once Palladium',
    name_en: '1 Oz Palladium',
    category: 'palladium',
    emoji: '⬜',
  },
  {
    id: 'palladium_10g',
    name_fr: '10g Palladium',
    name_en: '10g Palladium',
    category: 'palladium',
    emoji: '⬜',
  },
  {
    id: 'palladium_100g',
    name_fr: '100g Palladium',
    name_en: '100g Palladium',
    category: 'palladium',
    emoji: '⬜',
  },
];

export function searchPreciousMetals(query: string): PreciousMetal[] {
  if (!query || query.length < 1) return [];
  const q = query.toLowerCase();
  return PRECIOUS_METALS.filter(
    (m) =>
      m.name_fr.toLowerCase().includes(q) ||
      m.name_en.toLowerCase().includes(q) ||
      m.category.toLowerCase().includes(q) ||
      m.id.toLowerCase().includes(q)
  ).slice(0, 10);
}

export function getPopularMetals(): PreciousMetal[] {
  return PRECIOUS_METALS.filter((m) => m.popular);
}
